import { NgModule } from '@angular/core'
import { SharedModule } from '../../core/modules/shared.module'
import { RouterModule, Routes } from '@angular/router'
import { LoginModule } from './login/login.module'
import { LoginComponent } from './login/login.component'
import { PinloginModule } from './2fa/pinlogin.module'
import { PinloginComponent } from './2fa/pinlogin.component'
import { DeviceService } from './service/device.service'
import { LockModule } from './lock/lock.module'
import { LockComponent } from './lock/lock.component'

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '2fa',
    component: PinloginComponent,
  },
  {
    path: 'lock',
    component: LockComponent,
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes), SharedModule, LoginModule, PinloginModule, LockModule],
  providers: [DeviceService],
  declarations: [],
})
export class AuthenticationModule {}



// WEBPACK FOOTER //
// ./src/app/main/authentication/authentication.module.ts